import styled from 'styled-components'

export const PunchOutOrderInfoStyled = styled.div`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
